import call from "./call";
import { Language } from "../Models/languageModel";

export const fetchLanguages = async (): Promise<Language[]> => {
  const response = await call.get("/v1/evaluation/language/", {
    snack: {
      error: "language.fetchError",
    },
  });
  return response.data;
};
